// removed by extract-text-webpack-plugin
module.exports = {"item-grid":"item-grid___1ONpx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemCard/ItemGrid.scss
// module id = M7vW
// module chunks = 46